////// Lib. //////
//////////////////

import LazyLoad from "vanilla-lazyload";

// Module //
//////////////////

let instance = null;
const SHARED_OPTS = {
  class_loading: "is-loading",
  class_loaded: "is-loaded",
  class_error: "is-error",
  unobserve_completed: true,
};

// Single shared instance for the whole site. The viewport root also covers the
// project viewer's horizontal image stream: IntersectionObserver accounts for
// the track's translateX and its overflow-hidden ancestor, so off-track images
// correctly report as non-intersecting without a per-container instance.
export function initLazyLoad() {
  if (instance) return instance;
  instance = new LazyLoad({
    elements_selector: ".lazy",
    thresholds: "300px 600px", // Vertical page-scroll buffer / horizontal stream preload buffer.
    ...SHARED_OPTS,
  });

  return instance;
}

// Rescans the DOM for new `.lazy` elements — needed after a Swup content swap
// and after the image stream injects its images.
export function refreshLazyLoad() {
  instance?.update();
}

// Forces images that never intersect the viewport (e.g. fixed overlays) to load.
export function loadLazyElements(elements) {
  elements.forEach((el) => LazyLoad.load(el));
}

// rootMargin only dilates the observer's own root, never an intermediate clipping
// ancestor. Components whose own overflow-hidden element exactly matches the viewport
// (e.g. a fixed inset-0 full-screen root) sit between their images and the shared
// instance's implicit (document) root, so its buffer never applies to them. Give such
// a component its own instance rooted at that element instead.
export function createScopedLazyLoad(container, thresholds = "600px") {
  return new LazyLoad({
    elements_selector: ".lazy",
    container,
    thresholds,
    ...SHARED_OPTS,
  });
}
